import gql from "graphql-tag";

export const TRIPLEPLAY_GET_CALCULATION_DATA = gql`
	query CalculationData(
		$comparisonId: String!
	) {
		calculationData(comparisonId: $comparisonId) {
		comparisonId
			comparisonId
			calculationDate
			calculationInput {
				commonTechnical {
					senderId
					sessionId
					transactionReference
					googleAnalyticsId
					accessCode
				}
				policyPolicyDetails {
					partyPolicyHolders {
						addresses {
							houseNumber
							houseNumberAddition
							postalCode
						}
					}
					customProperties{
						customAttributes{
							description
							value
						}
					}
				}
			}
			calculationOutput{
				policyPolicyDetails {
					refKey
					companyNameDescription
					underwritingCompanySpecifics {
						refKey,
						underwritingResult
					}
					customProperties {
						customAttributes {
							description
							value
						},
						supplierKrn
					},
					grossPremiumInstallment,
					netPremiumInstallment,
					paymentTermInMonths,
					totalInstallmentAmount
				}
			}
			traces {
				providerTraces {
					krn
					message
					numberOfProducts
					elapsedMillisecondsDuration
				}
				productTraces {
					krn
					supplierName
					totalInstallmentAmount
					underwritingResult
					productStatus
					filteredOut
				}
			}
			
		}
	}


`;
